import { RenderTextInput } from "app/common/renderInput";
import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import DatePicker, { CalendarContainer } from "react-datepicker";
import { IoMdCloseCircle } from "react-icons/io";
const calenderCheckIn = ({ className, children }) => {
  return (
    <div>
      <CalendarContainer className={className}>
        <div
          style={{ background: "#f0f0f0" }}
          className="text-primary text-center shadow-sm"
        >
          <strong style={{ fontSize: 16 }}>Penalty Starts From</strong>
        </div>
        <div style={{ position: "relative" }}>{children}</div>
      </CalendarContainer>
    </div>
  );
};
const calenderCheckout = ({ className, children }) => {
  return (
    <div>
      <CalendarContainer className={className}>
        <div
          style={{ background: "#f0f0f0" }}
          className="text-primary text-center shadow-sm"
        >
          <strong style={{ fontSize: 16 }}>Penalty Ends On</strong>
        </div>
        <div style={{ position: "relative" }}>{children}</div>
      </CalendarContainer>
    </div>
  );
};
export default function CancellationDetails({
  values,
  setFieldValue,
  setState,
  errors,
  handleChange,
  handleBlur,
  touched,
}) {
  const checkOutRef = useRef(null);
  const addCancellationDay = () => {
    debugger;

    const newRoomDetail = {
      fdt: new Date(),
      tdt: new Date(),
      am: 0,
    };

    const updatedCancellationDetails = [
      ...values.cancellation.pd,
      newRoomDetail,
    ];
    setFieldValue("cancellation.pd", updatedCancellationDetails);
    setState((prev) => ({
      ...prev,
      cancellation: {
        ...prev.cancellation,
        pd: updatedCancellationDetails,
      },
    }));
  };
  const handleDeleteCancellationDay = (index) => {
    const updated = values.cancellation.pd.filter((_, i) => i !== index);
    setFieldValue("cancellation.pd", updated);
    setState((prev) => ({
      ...prev,
      cancellation: {
        ...prev.cancellation,
        pd: updated,
      },
    }));
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-6 mb-3">
          {/* {index == 0 && ( */}
          <label style={{ fontWeight: "bold" }} className="mb-1">
            Cancellation Id
          </label>
          {/* // )} */}

          <RenderTextInput
            type="text"
            name={`cancellation.id`}
            // display="Affiliate Service"
            placeholder="Cancellation Id"
            value={values?.cancellation?.id}
            error={errors?.cancellation?.id}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.cancellation?.id}
          ></RenderTextInput>
        </div>
      </div>
      {values?.cancellation?.pd?.map((seg, index) => (
        <div className="row" key={index}>
          <div className="col-md-4 mb-3">
            {/* {index == 0 && ( */}
            <label htmlFor="checkInDate" className="heading mb-4">
              Penalty Starts From
            </label>
            {/* // )} */}
            <DatePicker
              showIcon
              className="form-select"
              dateFormat="dd-MM-yyyy"
              selected={values?.cancellation?.pd?.[index]?.fdt}
              withPortal
              onChange={(date) => {
                const updated = [...values.cancellation.pd];

                updated[index].fdt = date;
                setFieldValue("cancellation.pd", updated);
              }}
              calendarContainer={calenderCheckIn}
            />
          </div>

          <div className="col-md-4 mb-3">
            {/* {index == 0 && ( */}
            <label htmlFor="checkOutDate" className="heading mb-4">
              Penalty Ends On
            </label>
            {/* // )} */}
            <DatePicker
              withPortal
              className="form-select"
              dateFormat="dd-MM-yyyy"
              selected={values?.cancellation?.pd?.[index]?.tdt}
              minDate={values?.cancellation?.pd?.[index]?.tdt}
              calendarContainer={calenderCheckout}
              onChange={(date) => {
                const updated = [...values.cancellation.pd];
                updated[index].tdt = date;
                setFieldValue("cancellation.pd", updated);
              }}
            />
          </div>
          <div className="col-md-3 mb-3">
            {/* {index == 0 && ( */}
            <label style={{ fontWeight: "bold" }} className="mb-1">
              Penalty Amount
            </label>
            {/* // )} */}

            <RenderTextInput
              type="number"
              name={`cancellation.pd.[${index}].am`}
              // display="Affiliate Service"
              placeholder="Penalty Amount"
              value={values?.cancellation?.pd?.[index]?.am}
              error={errors?.cancellation?.pd?.[index]?.am}
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={handleBlur}
              touched={touched?.cancellation?.pd?.[index]?.am}
            ></RenderTextInput>
          </div>
          <div className="col-md-1 mb-3">
            <div className="mb-3 d-flex justify-content-end">
              {index != 0 ? (
                <div>
                  <IoMdCloseCircle
                    size={20}
                    className="cursor-pointer text-danger"
                    onClick={() => handleDeleteCancellationDay(index)}
                  />
                </div>
              ) : (
                <div>
                  <IoMdCloseCircle size={20} className="text-white" />
                </div>
              )}
            </div>
            <div className="row d-flex justify-content-end align-items-end pt-2">
              <Button
                style={{ zIndex: 0 }}
                variant="primary"
                onClick={() => addCancellationDay()}
              >
                +
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
